import { Box, Text } from '@chakra-ui/react'

import { StatusPill } from '@hivewatch/dark'

import {
  AssociatedDevice,
  GridEnabled,
  TailgateEnabled,
} from '@/components/icons'

const STATUS_ROWS = [
  {
    variant: 'teal' as const,
    icon: <AssociatedDevice />,
    title: 'Associated',
    description:
      'Device has at least one association. By default, Associated devices include those with Grids Drawn and Tailgating Enabled.',
  },
  {
    variant: 'teal-blue' as const,
    icon: <GridEnabled />,
    title: 'Grids Drawn',
    description:
      'Device has at least one association and has grids configured. By default, devices with Grids Drawn include Tailgating Enabled devices.',
  },
  {
    variant: 'teal-green' as const,
    icon: <TailgateEnabled />,
    title: 'Tailgating Enabled',
    description:
      'Device has at least one association, has grids configured, and is tracking Tailgating behavior.',
  },
]

export const DeviceAssociationStatus = () => {
  return (
    <>
      {STATUS_ROWS.map(({ variant, icon, title, description }) => (
        <Box alignItems='center' display='flex' gap='12px' key={title}>
          <Box flexShrink={0}>
            <StatusPill h='24px' icon={icon} variant={variant} />
          </Box>
          <Text color='text.primary' fontSize='14px' lineHeight='20px'>
            <Text as='span' fontWeight='bold'>
              {title}
            </Text>{' '}
            &mdash; {description}
          </Text>
        </Box>
      ))}
    </>
  )
}
